export default {
    "faArchive": "mrkn fa-archive",
    "faAsterisk": "mrkn fa-asterisk",
    "faBan": "mrkn fa-ban",
    "faBell": "mrkn fa-bell",
    "faBirthdayCake": "mrkn fa-birthday-cake",
    "faBlackTie": "mrkn fa-black-tie",
    "faBolt": "mrkn fa-bolt",
    "faBriefcase": "mrkn fa-briefcase",
    "faBuilding": "mrkn fa-building",
    "faBus": "mrkn fa-bus",
    "faCalendarAlt": "mrkn fa-calendar-alt",
    "faCalendarDay": "mrkn fa-calendar-day",
    "faCarBuilding": "mrkn fa-car-building",
    "faCar": "mrkn fa-car",
    "faCheckCircle": "mrkn fa-check-circle",
    "faCheckDouble": "mrkn fa-check-double",
    "faCircleONotch": "mrkn fa-circle-o-notch",
    "faClipboardList": "mrkn fa-clipboard-list",
    "faClock": "mrkn fa-clock",
    "faCloudUpload": "mrkn fa-cloud-upload",
    "faCog": "mrkn fa-cog",
    "faCompressArrowsAlt": "mrkn fa-compress-arrows-alt",
    "faDatabase": "mrkn fa-database",
    "faDirections": "mrkn fa-directions",
    "faDollar": "mrkn fa-dollar",
    "faDotCircle": "mrkn fa-dot-circle",
    "faDownload": "mrkn fa-download",
    "faEar": "mrkn fa-ear",
    "faEnvelopeOpenDollar": "mrkn fa-envelope-open-dollar",
    "faEnvelopeOpenText": "mrkn fa-envelope-open-text",
    "faEnvelopeSolid": "mrkn fa-envelope-solid",
    "faEnvelope": "mrkn fa-envelope",
    "faEuroSign": "mrkn fa-euro-sign",
    "faExclamationTriangle": "mrkn fa-exclamation-triangle",
    "faExpandArrowsAlt": "mrkn fa-expand-arrows-alt",
    "faEyeSlash": "mrkn fa-eye-slash",
    "faEye": "mrkn fa-eye",
    "faFaxSolid": "mrkn fa-fax-solid",
    "faFax": "mrkn fa-fax",
    "faFileInvoiceDollar": "mrkn fa-file-invoice-dollar",
    "faFilePdf": "mrkn fa-file-pdf",
    "faFlag": "mrkn fa-flag",
    "faGlobeAmericas": "mrkn fa-globe-americas",
    "faGlobeEurope": "mrkn fa-globe-europe",
    "faGlobe": "mrkn fa-globe",
    "faHatCowboySide": "mrkn fa-hat-cowboy-side",
    "faHistory": "mrkn fa-history",
    "faHome": "mrkn fa-home",
    "faInfoCircle": "mrkn fa-info-circle",
    "faKey": "mrkn fa-key",
    "faLink": "mrkn fa-link",
    "faLiraSign": "mrkn fa-lira-sign",
    "faLocation": "mrkn fa-location",
    "faLongArrowDown": "mrkn fa-long-arrow-down",
    "faLongArrowUp": "mrkn fa-long-arrow-up",
    "faMapMarkedAlt": "mrkn fa-map-marked-alt",
    "faMapMarkerEdit": "mrkn fa-map-marker-edit",
    "faMinusSquareO": "mrkn fa-minus-square-o",
    "faMinus": "mrkn fa-minus",
    "faMobileAlt": "mrkn fa-mobile-alt",
    "faMoneyBillWave": "mrkn fa-money-bill-wave",
    "faPaperPlaneOutline": "mrkn fa-paper-plane-outline",
    "faPaperPlane": "mrkn fa-paper-plane",
    "faPencil": "mrkn fa-pencil",
    "faPercent": "mrkn fa-percent",
    "faPercentage": "mrkn fa-percentage",
    "faPhoneAlt": "mrkn fa-phone-alt",
    "faPig": "mrkn fa-pig",
    "faPlaneArrival": "mrkn fa-plane-arrival",
    "faPlaneDeparture": "mrkn fa-plane-departure",
    "faPlane": "mrkn fa-plane",
    "faPlayCircle": "mrkn fa-play-circle",
    "faPlusCircle": "mrkn fa-plus-circle",
    "faPlusSquareO": "mrkn fa-plus-square-o",
    "faPoundSign": "mrkn fa-pound-sign",
    "faPowerOff": "mrkn fa-power-off",
    "faQuestionCircle": "mrkn fa-question-circle",
    "faQuoteRight": "mrkn fa-quote-right",
    "faReceipt": "mrkn fa-receipt",
    "faRetweet": "mrkn fa-retweet",
    "faRoute": "mrkn fa-route",
    "faRubleSign": "mrkn fa-ruble-sign",
    "faRupeeSign": "mrkn fa-rupee-sign",
    "faShekelSign": "mrkn fa-shekel-sign",
    "faSignOutAlt": "mrkn fa-sign-out-alt",
    "faSms": "mrkn fa-sms",
    "faSortAlphaDownAlt": "mrkn fa-sort-alpha-down-alt",
    "faSortAlphaUp": "mrkn fa-sort-alpha-up",
    "faSpinnerThird": "mrkn fa-spinner-third",
    "faSquareO": "mrkn fa-square-o",
    "faStar": "mrkn fa-star",
    "faStickyNote": "mrkn fa-sticky-note",
    "faStripeS": "mrkn fa-stripe-s",
    "faSuitcaseRolling": "mrkn fa-suitcase-rolling",
    "faTenge": "mrkn fa-tenge",
    "faTerminal": "mrkn fa-terminal",
    "faTicketAlt": "mrkn fa-ticket-alt",
    "faTimesCircleHallow": "mrkn fa-times-circle-hallow",
    "faTimesCircle": "mrkn fa-times-circle",
    "faUnlink": "mrkn fa-unlink",
    "faUserCog": "mrkn fa-user-cog",
    "faUserFriends": "mrkn fa-user-friends",
    "faUserHardHat": "mrkn fa-user-hard-hat",
    "faUserPlus": "mrkn fa-user-plus",
    "faUserTieSolid": "mrkn fa-user-tie-solid",
    "faUserTie": "mrkn fa-user-tie",
    "faUser": "mrkn fa-user",
    "faWonSign": "mrkn fa-won-sign",
    "faWrench": "mrkn fa-wrench",
    "faYenSign": "mrkn fa-yen-sign",
    "ionAndroidAddCircle": "mrkn ion-android-add-circle",
    "ionAndroidCalendar": "mrkn ion-android-calendar",
    "ionAndroidPrint": "mrkn ion-android-print",
    "ionArrowDownB": "mrkn ion-arrow-down-b",
    "ionArrowLeftB": "mrkn ion-arrow-left-b",
    "ionArrowRightB": "mrkn ion-arrow-right-b",
    "ionArrowUpB": "mrkn ion-arrow-up-b",
    "ionBackspaceOutline": "mrkn ion-backspace-outline",
    "ionCard": "mrkn ion-card",
    "ionClock": "mrkn ion-clock",
    "ionIosClockOutline": "mrkn ion-ios-clock-outline",
    "ionIosClock": "mrkn ion-ios-clock",
    "ionMinusRound": "mrkn ion-minus-round",
    "ionPersonAdd": "mrkn ion-person-add",
    "ionRefresh": "mrkn ion-refresh",
    "ionTrashA": "mrkn ion-trash-a",
    "miscAccount": "mrkn misc-account",
    "miscAt": "mrkn misc-at",
    "miscBanknote": "mrkn misc-banknote",
    "miscCar": "mrkn misc-car",
    "miscCheck": "mrkn misc-check",
    "miscCheckeredFlag": "mrkn misc-checkered-flag",
    "miscClone": "mrkn misc-clone",
    "miscCross": "mrkn misc-cross",
    "miscDashboard": "mrkn misc-dashboard",
    "miscDownArrow": "mrkn misc-down-arrow",
    "miscEnvelope": "mrkn misc-envelope",
    "miscFactory": "mrkn misc-factory",
    "miscFirecracker": "mrkn misc-firecracker",
    "miscForm": "mrkn misc-form",
    "miscGavel": "mrkn misc-gavel",
    "miscGnetGLogo": "mrkn misc-gnet-g-logo",
    "miscGoogleCalendar": "mrkn misc-google-calendar",
    "miscGoogleMapsOld": "mrkn misc-google-maps-old",
    "miscGoogleMaps": "mrkn misc-google-maps",
    "miscHamburger": "mrkn misc-hamburger",
    "miscHotel": "mrkn misc-hotel",
    "miscInsights": "mrkn misc-insights",
    "miscKilometers": "mrkn misc-kilometers",
    "miscLogout": "mrkn misc-logout",
    "miscMapMarker": "mrkn misc-map-marker",
    "miscMask": "mrkn misc-mask",
    "miscMic": "mrkn misc-mic",
    "miscMiles": "mrkn misc-miles",
    "miscOpenBook": "mrkn misc-open-book",
    "miscPackage": "mrkn misc-package",
    "miscPassengers": "mrkn misc-passengers",
    "miscPayPartial": "mrkn misc-pay-partial",
    "miscPhone": "mrkn misc-phone",
    "miscPlus": "mrkn misc-plus",
    "miscRightArrow": "mrkn misc-right-arrow",
    "miscSave": "mrkn misc-save",
    "miscSubscription": "mrkn misc-subscription",
    "miscTwilio": "mrkn misc-twilio",
    "miscUser": "mrkn misc-user",
    "miscUsers": "mrkn misc-users"
};